import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageview } from '../helpers/analytics'

// Fires a GA4 page view on every client-side navigation. This is a genuine
// external sync (reporting to GA), so useEffect is the right tool. It stays a
// no-op until the user has granted consent (trackPageview guards internally).
export const usePageTracking = () => {
  const { pathname, search } = useLocation()
  useEffect(() => {
    trackPageview(pathname + search)
  }, [pathname, search])
}
